let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e6Ahe")).then(() => parcelRequire('9NAtJ'));